import React, { useEffect } from "react";
import { track } from "../lib/checkout";

import AnnouncementBar from "../components/AnnouncementBar";
import HeroV2 from "../components/HeroV2";
import SocialProof from "../components/SocialProof";
import ThisIsForYou from "../components/ThisIsForYou";
import ProblemSection from "../components/ProblemSection";
import WhatYouBuild from "../components/WhatYouBuild";
import ViralXDemo from "../components/ViralXDemo";
import Outcomes from "../components/Outcomes";
import WhoForNotFor from "../components/WhoForNotFor";
import FounderAuthority from "../components/FounderAuthority";
import ValueStack from "../components/ValueStack";
import FAQ from "../components/FAQ";
import FinalCTA from "../components/FinalCTA";
import FloatingBar from "../components/FloatingBar";
import CursorFollow from "../components/CursorFollow";
import ConfettiBlast from "../components/ConfettiBlast";

// Scroll-depth thresholds (percent)
const DEPTH_MARKS = [25, 50, 75, 90];

export default function Landing() {
  // Fire PageView + ViewContent once per session
  useEffect(() => {
    track("PageView");
    track("ViewContent", {
      content_name: "AI Money Machine System",
      content_category: "workshop_landing",
      value: 199,
      currency: "INR",
    });
  }, []);

  // Scroll depth tracking
  useEffect(() => {
    const fired = new Set();
    const onScroll = () => {
      const doc = document.documentElement;
      const total = doc.scrollHeight - window.innerHeight;
      if (total <= 0) return;
      const pct = Math.round(((window.scrollY || doc.scrollTop) / total) * 100);
      DEPTH_MARKS.forEach((m) => {
        if (pct >= m && !fired.has(m)) {
          fired.add(m);
          track("ScrollDepth", { percent: m });
        }
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen tech-bg text-white overflow-x-hidden relative">
      <ConfettiBlast />
      <CursorFollow />
      <AnnouncementBar />

      <HeroV2 />

      <SocialProof />
      <ThisIsForYou />
      <ProblemSection />
      <WhatYouBuild />
      <ViralXDemo />
      <Outcomes />
      <WhoForNotFor />
      <FounderAuthority />
      <ValueStack />
      <FAQ />
      <FinalCTA />

      <FloatingBar />
    </div>
  );
}
